import httpClient from "../http/http-client";
import { IReductionTargetPageState, ITargetSetting } from './target-setting.model';

export default class TargetSettingService {
  http;

  constructor() {
    this.http = httpClient
  }

  async saveTarget(details: ITargetSetting): Promise<any> {
    return this.http.post('target-setting', details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getTargetSettings(): Promise<any> {
    return this.http.get('target-setting')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getReductionTargetPageState(): Promise<IReductionTargetPageState> {
    return this.http.get('reduction-target/page-state')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async deleteTargetSetting(): Promise<any> {
    return this.http.delete('target-setting')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

}
